import { Outlet } from 'react-router-dom';

export const AdminApp = () => {
  return <Outlet />;
};
